import { CSSProperties, ReactElement } from "react";
import clsx from "clsx";

export const TopbarContainer = ({
  children,
  className,
  style,
}: {
  children: ReactElement | ReactElement[];
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <div
      className={clsx(
        "flex h-[80px] items-center justify-between border-b border-slate-200 px-6 py-[20px]",
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
};
